export default __webpack_public_path__ + "static/css/8b6421cb572065c8f388f14fd596ada3.css";